module.exports = __webpack_public_path__ + "img/alert.ae84539e.svg";